import { render, staticRenderFns } from "./PropertiesOfRequestedDid.vue?vue&type=template&id=d360d8b6&scoped=true&"
import script from "./PropertiesOfRequestedDid.vue?vue&type=script&lang=js&"
export * from "./PropertiesOfRequestedDid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d360d8b6",
  null
  
)

export default component.exports